import React from "react";
import ApplicationHeader from "../components/Headers/ApplicationHeader/ApplicationHeader";
import BasketManagement from "../components/Basket/BasketsManagement/BasketManagement";
import HomePage from "./home/HomePage";
import { useAuth } from "../components/Auth/useAuth";

function Main() {
  const [auth] = useAuth();
  const clientProfileId = auth?.user?.client_profile?.id;

  return (
    <React.Fragment>
      <ApplicationHeader />
      {clientProfileId && <BasketManagement />}
      <HomePage />
    </React.Fragment>
  );
}

export default Main;
